/* global getCookie */

if (!customElements.get("cart-drawer-discounts")) {
  function getCookie(name) {
    const cookieString = `; ${document.cookie}`;
    const cookies = cookieString.split(`; ${name}=`);

    if (cookies.length === 2) {
      return decodeURIComponent(cookies.pop().split(";").shift());
    }

    return null;
  }

  class CartDrawerDiscounts extends HTMLElement {
    constructor() {
      super();
      this.discountListContainerEl = document.querySelector(
        "#discountListContainer"
      );
      this.discountFormEl = this.querySelector("form.discount-form");
      this.submitButton = this.querySelector("#discountSubmit");
      this.discountInputEl = this.querySelector("input.discount-input");
      this.discountErrorEl = this.querySelector(".discount-error");
      this.init();
    }

    init() {
      // Apply discount if it exists in local storage
      if (localStorage.discountCode) {
        const code = JSON.parse(localStorage.discountCode).code;
        this.applyDiscount({ code, isInit: true });
      } else {
        const discountCookie = getCookie("discount_code");

        if (discountCookie && discountCookie != "CLEAR") {
          this.applyDiscount({ code: discountCookie, isInit: false });
        }
      }

      this.discountFormEl.addEventListener("submit", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const discountCode = this.discountInputEl.value;
        if (discountCode.length < 1) return;
        this.applyDiscount({ code: discountCode, isInit: false });
      });

      this.submitButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const discountCode = this.discountInputEl.value;

        if (discountCode.length < 1) return;

        this.applyDiscount({ code: discountCode, isInit: false });
      });

      document
        .querySelectorAll(".js-remove-discount")
        .forEach((el) =>
          el.addEventListener("click", this.clearDiscount.bind(this))
        );
    }

    clearDiscount() {
      this.discountListContainerEl?.classList.add("hidden");

      setTimeout(() => {
        this.updateCartPrice();
      }, 500);

      this.clearLocalStorage();
      window.appliedDiscounts = null;
      fetch("/checkout?discount=%20");
      fetch("/discount/CLEAR");
    }

    clearLocalStorage() {
      localStorage.removeItem("discountCode");
    }

    createDiscountElements(discountApplications) {
      const discountListContainerEl = document.querySelector(
        "#discountListContainer"
      );
      this.discountListContainerEl = discountListContainerEl;

      const discountListEl =
        discountListContainerEl && discountListContainerEl.querySelector("ul");
      const discountEl = discountListEl.querySelector("li");
      discountListEl.innerHTML = "";

      discountApplications.forEach((discount) => {
        const discountString = `${discount.title} (${discount.amount} ${Shopify.currency.active})`;
        const element = discountEl.cloneNode(true);

        element.innerHTML = element.innerHTML.replace(
          "[PLACEHOLDER]",
          discountString
        );

        discountListEl.appendChild(element);
      });

      discountListContainerEl.classList.remove("hidden");

      document
        .querySelectorAll(".js-remove-discount")
        .forEach((el) =>
          el.addEventListener("click", this.clearDiscount.bind(this))
        );
    }

    updateCartPrice() {
      const changeEvent = new Event("change", { bubbles: true });
      const input = document.querySelector("#quantity-1.qty-input__input");

      const drawer = document.querySelector("cart-drawer");
      const drawerItem = drawer.querySelector("cart-items");
      if (drawerItem) {
        drawerItem.refresh(true);
      }
    }

    fetchPaymentConfig() {
      return fetch("/payments/config", { method: "GET" }).then((response) =>
        response.json()
      );
    }

    fetchCart() {
      return fetch("/cart.js", {}).then((res) => res.json());
    }

    createCheckoutBody(data, code) {
      return {
        checkout: {
          country: Shopify.country,
          discount_code: code,
          line_items: data.items,
          presentment_currency: Shopify.currency.active,
        },
      };
    }

    fetchCheckout(body, authorization_token) {
      const checkout_json_url = "/wallets/checkouts/";
      return fetch(checkout_json_url, {
        headers: {
          accept: "*/*",
          "cache-control": "no-cache",
          authorization: "Basic " + authorization_token,
          "content-type": "application/json, text/javascript",
          pragma: "no-cache",
          "sec-fetch-dest": "empty",
          "sec-fetch-mode": "cors",
          "sec-fetch-site": "same-origin",
        },
        referrerPolicy: "strict-origin-when-cross-origin",
        method: "POST",
        mode: "cors",
        credentials: "include",
        body: JSON.stringify(body),
      }).then((response) => response.json());
    }

    applyDiscount({ code, isInit }) {
      this.fetchPaymentConfig().then((data) => {
        const authorization_token = btoa(data.paymentInstruments.accessToken);

        this.fetchCart().then((data) => {
          const body = this.createCheckoutBody(data, code);

          this.fetchCheckout(body, authorization_token)
            .then((data) => {
              if (data.checkout && data.checkout.applied_discounts.length > 0) {
                const discountApplyUrl =
                  "/discount/" +
                  code +
                  "?v=" +
                  Date.now() +
                  "&redirect=/checkout/";
                fetch(discountApplyUrl, {}).then((response) => response.text());

                const appliedDiscounts = data.checkout.applied_discounts;
                window.appliedDiscounts = appliedDiscounts;

                const lineItemPrice = data.checkout.total_line_items_price;

                const localStorageValue = {
                  code: code.trim(),
                  totalCart: lineItemPrice,
                };
                localStorage.setItem(
                  "discountCode",
                  JSON.stringify(localStorageValue)
                );

                if (!isInit) {
                  setTimeout(() => {
                    this.createDiscountElements(appliedDiscounts);
                    this.discountListContainerEl.classList.remove("hidden");
                  }, 3500);
                } else {
                  this.createDiscountElements(appliedDiscounts);
                  this.discountListContainerEl.classList.remove("hidden");
                }

                this.discountErrorEl.classList.add("hidden");
                try {
                  this.closest("cart-drawer-disclosure").close();
                } catch (error) {
                  //doesn't matter, it just isn't inside a cart-drawer-disclosure
                }

                if (!isInit) {
                  this.updateCartPrice();
                  setTimeout(() => {
                    this.updateCartPrice();
                  }, 1000);
                }
              } else {
                this.clearDiscount();

                this.discountErrorEl.classList.remove("hidden");
                const reason =
                  data?.checkout?.applied_discount?.non_applicable_reason;
                if (reason) {
                  this.discountErrorEl.innerHTML = reason;
                }
              }
            })
            .finally(() => {
              //reactivate discount button
              this.discountInputEl.value = "";
            });
        });
      });
    }
  }

  customElements.define("cart-drawer-discounts", CartDrawerDiscounts);
}
